import { Image, Text, Button } from '@chakra-ui/react';
import { ReactElement, useEffect, useState } from 'react';
import { ModalBetaWallVariantProps, ModalTarget, SharedModalProps } from 'types/Modal';
import paywallImage from 'assets/subscription/paywall.png';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalBetaWallVariantProps;

export const BetaWallModal = ({ handleClose, isShown }: Props): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  const [target, setTarget] = useState<ModalTarget>(ModalTarget.PAGE_DESKTOP);

  useEffect(() => {
    if (isDesktop) {
      setTarget(ModalTarget.PAGE_DESKTOP);
    } else {
      setTarget(ModalTarget.PAGE_MOBILE);
    }
  }, [isDesktop]);

  const handleSupportClick = (): void => {
    window.open('mailto:support@novaheal.de?subject=Ich möchte an der Beta teilnehmen', '_blank');
  };

  return (
    <CustomModal
      isOpen={isShown}
      onClose={handleClose}
      hideHeader
      placement="center"
      target={target}
      size="lg"
    >
      <CustomModalContent
        display="flex"
        gap="25px"
        flexDirection="column"
        alignItems="center"
        p="40px 30px"
      >
        <Image src={paywallImage} maxWidth="400px" />
        <Text textStyle="h2.medium">Dieses Feature ist nur für Beta Tester:innen zugänglich</Text>
        <Text textStyle="body.m.regular">
          Du bist derzeit nicht berechtigt, auf diese Funktion zuzugreifen. Gegebenenfalls, ist der
          Testzeitraum abgelaufen. Bitte wende dich an den Support, um weitere Informationen zu
          erhalten.
          <br />
          Wenn du an der Beta-Phase teilnehmen möchtest, wende dich bitte an den Support.
          <br />
        </Text>
        <Button variant="primary" onClick={handleSupportClick}>
          Support kontaktieren
        </Button>
      </CustomModalContent>
    </CustomModal>
  );
};
